import { UniversalLink } from "@template/components";
import * as S from "./styles.ts";
import useCurrency from "@/lib/helpers/hooks/useCurrency.ts";

export type TContactInfo = {
  name?: string;
  phone_number?: string;
  email?: string;
  phone_number_US?: string;
};

export interface IFooterContactProps {
  contactInfo: TContactInfo;
}

const FooterContact = ({
  contactInfo: { name, phone_number, email, phone_number_US },
}: IFooterContactProps) => {
  const currency = useCurrency();
  if (currency === "$" && phone_number_US) {
    phone_number = phone_number_US;
  }

  return (
    <S.ContactContainer>
      {name && <S.ContactName>{name}</S.ContactName>}
      {(phone_number || email) && (
        <S.ContactInteractionContainer>
          {phone_number && (
            <UniversalLink href={`tel:${phone_number}`}>
              <S.ContactTrigger>{phone_number}</S.ContactTrigger>
            </UniversalLink>
          )}
          {email && (
            <UniversalLink href={`mailto:${email}`}>
              <S.ContactTrigger>{email}</S.ContactTrigger>
            </UniversalLink>
          )}
        </S.ContactInteractionContainer>
      )}
    </S.ContactContainer>
  );
};

export default FooterContact;
